<template>
  <li
    tabindex="0"
    :class="rootClassName"
    @click="handleClick"
    @keydown="handleKeydown">
		<p>
    	<slot />
		</p>
  </li>
</template>

<script>
export default {
  name: 'RegistryItem',

  inject: [ 'Registry' ],

  props: {
    value: String,
    indented: Boolean,
  },

  computed: {
    rootClassName: function () {
      return [
        this.$style.root,
        {
          [ this.$style.selected ]: this.value === this.Registry.value,
          [ this.$style.indented ]: this.indented
        }
      ]
    }
  },

  methods: {
    handleClick: function (e) {
      this.Registry.handleSelect(this.value, e)
    },

    handleKeydown: function (e) {
      const { key } = e

      if (key === 'Enter') {
        this.Registry.handleSelect(this.value, e)
      }
    }
  }
}

</script>

<style module>

.root {
  @apply
    outline-none
    cursor-pointer
    my-1
    text-secondary-dark
    rounded-lg
    bg-white;
}
 
.root:hover:not(.selected),
.root:focus:not(.selected) {
  @apply
    text-primary;
}

.selected {
  @apply
    bg-dull-light
    text-primary;
}

</style>
